export const COMPLETION_PROGRESS_MODE_NORMALIZED = "normalized";
export const COMPLETION_PROGRESS_MODE_FLAT = "flat";
export const COMPLETION_PROGRESS_MODE_WEIGHTED = "weighted";

// Field → content payload key. Mirrors StoryEntity::FOLDER_COUNT_KEYS (PHP).
export const FOLDER_COUNT_KEYS = Object.freeze({
  childNodes: "child_nodes",
  notStartedChildNodes: "not_started_child_nodes",
  startedChildNodes: "started_child_nodes",
  completedChildNodes: "completed_child_nodes",
  leafNodesInTree: "leaf_nodes_in_tree",
  notStartedLeafNodesInTree: "not_started_leaf_nodes_in_tree",
  startedLeafNodesInTree: "started_leaf_nodes_in_tree",
  completedLeafNodesInTree: "completed_leaf_nodes_in_tree",
});

export const FOLDER_COUNT_FIELD_LABELS = Object.freeze({
  childNodes: "Children",
  notStartedChildNodes: "Children not started",
  startedChildNodes: "Children in progress",
  completedChildNodes: "Children done",
  leafNodesInTree: "Leaf nodes",
  notStartedLeafNodesInTree: "Leaf nodes not started",
  startedLeafNodesInTree: "Leaf nodes in progress",
  completedLeafNodesInTree: "Leaf nodes done",
  completedChildNodesPercent: "Children done %",
  completedLeafNodesPercent: "Leaf nodes done %",
});

// Same rule as StoryEntity::completedPercent: 0 when empty, else the rounded share.
export function completedPercent(done, total) {
  const t = Number(total) || 0;
  return t > 0 ? Math.round((Number(done) || 0) / t * 100) : 0;
}

function countOf(src, field) {
  const value = src[field] ?? src[FOLDER_COUNT_KEYS[field]];
  return value == null ? null : Number(value);
}

// Snake (content payload) or camel (/story record) → the eight counts + both percents; absent counts stay null.
export function folderCountsFrom(src) {
  const record = src || {};
  const counts = {};
  for (const field of Object.keys(FOLDER_COUNT_KEYS)) {
    counts[field] = countOf(record, field);
  }
  counts.completedChildNodesPercent = completedPercent(counts.completedChildNodes, counts.childNodes);
  counts.completedLeafNodesPercent = completedPercent(counts.completedLeafNodesInTree, counts.leafNodesInTree);
  return counts;
}

// Folder completion % per mode: flat (immediate children), weighted (#82 leaf
// nodes), normalized (#40 server percent, falling back to the flat ratio).
export function completionPercentForMode(mode, progress) {
  const p = progress || {};
  const children = p.childNodes ?? p.total;
  const childrenDone = p.completedChildNodes ?? p.completed;
  if (mode === COMPLETION_PROGRESS_MODE_FLAT) {
    return completedPercent(childrenDone, children);
  }
  if (mode === COMPLETION_PROGRESS_MODE_WEIGHTED) {
    return completedPercent(p.completedLeafNodesInTree, p.leafNodesInTree);
  }
  if (typeof p.percent === "number") {
    return p.percent;
  }
  return completedPercent(childrenDone, children);
}
